import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
}

export function EmptyState({ icon: Icon, title, subtitle }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 py-10 text-center w-full">
      <Icon size={32} strokeWidth={2} className="text-black/40 dark:text-white/40" />
      <div className="font-semibold text-[15px]">{title}</div>
      <div className="text-sm text-black/50 dark:text-white/50 max-w-xs">{subtitle}</div>
    </div>
  );
}
